import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../api";
import LoadingSpinner from "../components/LoadingSpinner";
import QuestionandAnswer from "../components/QuestionandAnswer";
import { ChevronLeft } from "lucide-react";

export default function QuestionAnswer() {
  const { childId } = useParams();
  const navigate = useNavigate();
  const [isEnabled, setIsEnabled] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStatus = async () => {
      try {
        const response = await api.get(`/children/profiles/${childId}/`);
        setIsEnabled(response.data.question_and_answer || false);
      } catch (error) {
        console.error("Error fetching status:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchStatus();
  }, [childId]);

  const handleEnableFeature = async () => {
    try {
      await api.patch(`/children/profiles/${childId}/`, { question_and_answer: true });
      setIsEnabled(true);
    } catch (error) {
      console.error("Error enabling feature:", error);
    }
  };

  if (loading) return <LoadingSpinner fullScreen={true} />;

  if (isEnabled) {
    return <QuestionandAnswer title="Question & Answer" />;
  }

  return (
    <div className="relative min-h-screen bg-white">
      <div className="relative z-10">
        <div className="bg-white/0 backdrop-blur-sm px-5 py-4 flex items-center justify-between">
          <button onClick={() => navigate(`child/${childId}`)} className="p-2">
            <ChevronLeft className="w-6 h-6 text-gray-800" />
          </button>
          <h1 className="text-lg font-semibold text-[#1e3a5f]">Question & Answer</h1>
          <div className="w-10" />
        </div>
        <div className="px-5 py-6 flex flex-col items-center min-h-[calc(100vh-140px)]">
          <div className="flex-1 flex flex-col items-center justify-center max-w-md w-full">
            <div className="mb-8">
              <img
                src="/qna.png"
                alt="Question & Answer Illustration"
                className="w-100 h-100 object-contain"
              />
            </div>
            <h2 className="text-2xl font-bold text-[#1e3a5f] text-center mb-4">
              Question & Answer
            </h2>
            <p className="text-gray-600 text-center mb-8 leading-relaxed">
              Get answers to your parenting questions from a community of experts and fellow parents.
            </p>
          </div>
          <div className="w-full max-w-md mt-auto pb-6">
            <button
              onClick={handleEnableFeature}
              className="w-full rounded-xl bg-[#1e3a5f] py-3.5 text-sm font-semibold text-white shadow-md transition-transform active:scale-98"
            >
              Ask a Question
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
